import { LitElement, html, css } from 'lit-element';
import { transition } from 'd3-transition';
import { SelectMixin } from '@preignition/preignition-mixin';

const stateValue = {
  square: {
    d: [
      'm 318.56,11.056 c 0,0 161.025,88.342 166.732,166.734 10.064,138.22 -188.875,195.44 -201.28,333.47 -5.556,61.8 35.745,166.735 35.745,166.735 0,0 -164.224,-86.598 -170.332,-165.535 C 138.652,373.25 341.445,316.823 354.305,177.79 360.019,116.005 318.558,11.056 318.558,11.056 Z',
      'm 365.725,40.35 c 0,0 143.535,92.18 148.622,162.056 8.97,123.205 -168.357,160.773 -179.415,283.81 -4.95,55.085 31.863,148.62 31.863,148.62 0,0 -146.385,-77.19 -151.83,-147.552 C 205.363,363.197 386.125,312.9 397.59,188.97 402.682,133.898 365.726,40.35 365.726,40.35 Z',
      'm 270.77,54.767 c 0,0 143.535,78.746 148.622,148.622 8.97,123.204 -168.357,174.207 -179.415,297.243 -4.952,55.086 31.862,148.622 31.862,148.622 0,0 -146.385,-90.624 -151.829,-160.987 C 110.407,364.18 291.17,327.317 302.633,203.389 307.727,148.314 270.77,54.766 270.77,54.766 Z',
    ],
    // x: [786],
    transform: [
      'translate(0,0)',
      'translate(0,0)',
      'translate(0,0)',
      'translate(0,0)',
    ],

    opacity: [
      0.85,
      0.8,
      0
    ],
    opacityDelay: [
      0,
      null,
      0
    ]

  },
  oneline: {
    d: [
      'm 318.56,11.056 c 0,0 161.025,88.342 166.732,166.734 10.064,138.22 -188.875,195.44 -201.28,333.47 -5.556,61.8 35.745,166.735 35.745,166.735 0,0 -164.224,-86.598 -170.332,-165.535 C 138.652,373.25 341.445,316.823 354.305,177.79 360.019,116.005 318.558,11.056 318.558,11.056 Z',
      'm 318.56,11.056 c 0,0 161.025,88.342 166.732,166.734 10.064,138.22 -188.875,195.44 -201.28,333.47 -5.556,61.8 35.745,166.735 35.745,166.735 0,0 -164.224,-86.598 -170.332,-165.535 C 138.652,373.25 341.445,316.823 354.305,177.79 360.019,116.005 318.558,11.056 318.558,11.056 Z',
      'm 318.56,11.056 c 0,0 161.025,88.342 166.732,166.734 10.064,138.22 -188.875,195.44 -201.28,333.47 -5.556,61.8 35.745,166.735 35.745,166.735 0,0 -164.224,-86.598 -170.332,-165.535 C 138.652,373.25 341.445,316.823 354.305,177.79 360.019,116.005 318.558,11.056 318.558,11.056 Z',

    ],
    // x: [976],
    transform: [
      'translate(-150,0)',
      'translate(170,184)scale(0.6)',
      'translate(-100,113)',
      'translate(190,0)'
    ],
    opacity: [
      0,
      0,
      0.95
    ],
    opacityDuration: [
      null,
      100,
      null
    ]
  }
};

class PreignitionLogo extends SelectMixin(LitElement) {

  static get styles() {
    return css `
    :host {
      display: block;
      --flame-color: var(--accent-color, #80CBC4);
      --circle-color: var(--logo-background-color, #37474F);
      --circle-shadow-color: var(--accent-color-tr);
      --logo-font-size: 50px;
      --logo-letter-spacing: -1.5px;
    }

    .hide-small {
      opacity: 1;
      -webkit-transition: opacity 400ms;
      transition: opacity 400ms;
    }

    :host([is-small]) .hide-small {
      opacity: 0;
    }


    .circle-shadow {
      fill: var(--circle-shadow-color);
    }
    
    .circle,
    .straight-shadow {
      fill: var(--circle-color);
    }

    .flame {
      fill: var(--flame-color);
    }

    .flame path {
      opacity: 0.5;
    }

    .light {
      opacity: 0.6;
    }

    .logo-text {
      fill: #ffffff;
    }

    .logo-font {
      text-align: start;
      font-family: Roboto;
      font-style: normal;
      font-variant: normal;
      font-weight: 300;
      font-size: var(--logo-font-size);
      letter-spacing: var(--logo-letter-spacing);
    }

    svg {
      width: 100%;
      height: 100%;
    }`;
  }

  /**
   * Implement `render` to define a template for your element.
   *
   * You must provide an implementation of `render` for any element
   * that uses LitElement as a base class.
   */
  render() {
    /**
     * `render` must return a lit-html `TemplateResult`.
     *
     * To create a `TemplateResult`, tag a JavaScript template literal
     * with the `html` helper function:
     */
    return html `
    <a href="${this.action}" >
      <svg id="logo" viewBox="0 -100 935 935">
        <path class="circle opacity" opacity="0.85" d="M934.968 367.484A467.484 467.484 0 1 1 0 367.484a467.484 467.484 0 1 1 934.968 0" />
        <path class="circle-shadow opacity" delay="1000" opacity="0.8" d="m 423.334,82.759 c -282.22267,501.47268 -141.11133,250.73634 0,0 z m 0,0 c 40.552,33.104 88.11,79.965 91,119.658 8.97,123.205 -168.348,160.776 -179.406,283.812 -4.95,55.087 31.875,148.594 31.875,148.594 -28.556,-15.74 -57.057,-34.733 -74.97,-48.188 5.465,22.817 15.34,59.93 27.908,91.282 L 550.585,827.604 C 741.555,793.344 892.279,643.1 927.273,452.384 L 423.334,82.762 Z" />
        <path class="straight-shadow opacity" opacity="0" d="M 50.03125 158.25977 A 467.484 467.484 0 0 0 0 367.48438 A 467.484 467.484 0 0 0 77.517578 624.27148 L 857.71289 624.27148 A 467.484 467.484 0 0 0 934.96875 367.48438 A 467.484 467.484 0 0 0 885.07227 158.25977 L 50.03125 158.25977 z " />
        <g class="transform">
          <g class="transform">
            <g class="flame">
              <path class="flame-1 d" d="m 318.56,11.056 c 0,0 161.025,88.342 166.732,166.734 10.064,138.22 -188.875,195.44 -201.28,333.47 -5.556,61.8 35.745,166.735 35.745,166.735 0,0 -164.224,-86.598 -170.332,-165.535 C 138.652,373.25 341.445,316.823 354.305,177.79 360.019,116.005 318.558,11.056 318.558,11.056 Z" />
              <path class="flame-2 d" d="m 365.725,40.35 c 0,0 143.535,92.18 148.622,162.056 8.97,123.205 -168.357,160.773 -179.415,283.81 -4.95,55.085 31.863,148.62 31.863,148.62 0,0 -146.385,-77.19 -151.83,-147.552 C 205.363,363.197 386.125,312.9 397.59,188.97 402.682,133.898 365.726,40.35 365.726,40.35 Z" />
              <path class="flame-3 d" d="m 270.77,54.767 c 0,0 143.535,78.746 148.622,148.622 8.97,123.204 -168.357,174.207 -179.415,297.243 -4.952,55.086 31.862,148.622 31.862,148.622 0,0 -146.385,-90.624 -151.829,-160.987 C 110.407,364.18 291.17,327.317 302.633,203.389 307.727,148.314 270.77,54.766 270.77,54.766 Z" />
            </g>
          </g>
          <g class="logo-text">
            <g class="light transform">
              <path d="M499.218 390.013c7.453 2.53 14.32 3.797 20.602 3.797 19.078 0 28.617 -10.617 28.617 -31.852 0 -18.89 -9.492 -28.336 -28.477 -28.336 -6.562 0 -13.476 .563 -20.742 1.688v54.703m-7.383 -59.977c8.39 -2.015 17.813 -3.023 28.266 -3.023 23.673 0 35.51 11.695 35.51 35.086 0 25.827 -11.908 38.74 -35.72 38.74 -5.906 0 -12.797 -1.17 -20.672 -3.515v30.156h-7.383v-97.444" />
              <path d="M567.683 400.84v-73.827h5.273l.914 12.234c7.407 -8.156 15.657 -12.234 24.75 -12.234v5.906c-8.812 0 -16.664 4.288 -23.554 12.866v55.055h-7.383" />
              <path d="M633.304 327.013c20.203 0 30.304 11.18 30.305 33.54a94.39 94.39 0 0 1 -.142 4.99h-56.04c0 19.314 10.22 28.97 30.657 28.97 8.39 0 15.844 -1.172 22.36 -3.516v6.33c-6.516 2.342 -13.97 3.514 -22.36 3.514 -25.36 0 -38.04 -12.585 -38.04 -37.757 0 -24.046 11.087 -36.07 33.26 -36.07m-25.876 31.922h49.077c-.28 -17.156 -8.016 -25.734 -23.203 -25.734 -16.407 0 -25.032 8.58 -25.875 25.735" />
            </g>
            <g class="transform">
              <path d="M400.307 439.3v73.84h-7.383V439.3h7.383" />
              <path d="M470.99 447.61c-6.796 -1.126 -13.476 -1.69 -20.04 -1.69 -19.92 0 -29.88 9.915 -29.88 29.744 0 20.296 9.303 30.445 27.913 30.445 6.75 0 14.086 -1.267 22.008 -3.798V447.61m7.383 65.53c0 17.813 -10.85 26.72 -32.554 26.72 -9.095 0 -17.158 -1.173 -24.19 -3.517v-6.328c7.173 2.344 15.282 3.516 24.33 3.516 16.687 0 25.03 -6.796 25.03 -20.39v-3.515c-8.343 2.343 -15.703 3.515 -22.078 3.515 -23.344 0 -35.015 -12.445 -35.015 -37.336 0 -24.328 12.54 -36.492 37.617 -36.492 9.515 0 18.47 1.008 26.86 3.023v70.805" />
              <path d="M492.104 513.14v-73.828h5.273l.914 9.422c9.423 -6.28 18.657 -9.422 27.704 -9.422 17.953 0 26.93 7.758 26.93 23.273v50.555h-7.383v-50.765c0 -10.97 -6.632 -16.454 -19.897 -16.454 -8.86 .002 -17.578 3.12 -26.157 9.353v57.867h-7.382" />
              <path d="M575.303 439.312v73.828h-7.383v-73.828h7.383" />
              <path d="M590.017 427.36h5.203l1.336 11.952h22.15v6.328h-21.517v46.617c0 9.703 3.562 14.555 10.687 14.555h10.828v6.328h-10.688c-12 0 -18 -6.633 -18 -19.898V427.36" />
              <path d="M634.404 439.312v73.828h-7.383v-73.828h7.384" />
              <path d="M653.267 475.945c0 21.047 9.023 31.57 27.07 31.57s27.07 -10.523 27.07 -31.57c0 -20.672 -9.023 -31.008 -27.07 -31.008s-27.07 10.336 -27.07 31.008m-7.383 .28c0 -25.077 11.485 -37.616 34.453 -37.616 22.97 0 34.453 12.538 34.453 37.616 0 25.03 -11.484 37.547 -34.453 37.547 -22.875 0 -34.36 -12.516 -34.453 -37.547" />
              <path d="M724.935 513.14v-73.828h5.273l.914 9.422c9.422 -6.28 18.657 -9.422 27.703 -9.422 17.953 0 26.93 7.758 26.93 23.273v50.555h-7.383v-50.765c0 -10.97 -6.633 -16.454 -19.898 -16.454 -8.86 .002 -17.578 3.12 -26.156 9.353v57.867h-7.383" />
            </g>
            <g class="logo-font hide-small">
              <text id="textLeft" x="388" y="590">${this.textLeft}</text>
              <text id="textRight" text-anchor="end" x="786" y="590">${this.textRight}</text>
            </g>
          </g>
        </g>
      </svg>
    </a>
    `;
  }

  constructor() {
    super();

    this.isSmall = false;
    this.textLeft = 'enabling';
    this.textRight = 'growth';
    this.duration = 400;
    this.state = 'square';
    this.action = '.';
    this.stateValue = stateValue;
  }

  static get properties() {
    return {

      action: {
        type: String
      },

      /*
       * `isSmall` when set to true, force small version and change the viewBox
       */
      isSmall: {
        type: Boolean,
        attribute: 'is-small'
      },

      /*
       * `textLeft` the text under logo, left aligned
       */
      textLeft: {
        type: String
      },

      /*
       * `subTextRight` the text under logo, right aligned
       */
      textRight: {
        type: String
      },

      /*
       * the `duration` for the animation  (in ms)
       */
      duration: {
        type: Number
      },

      /*
       * `state` state of the icon. Either `square` or `oneline`
       */
      state: {
        type: String
        // notify: true
      },

      /*
       * `stateValue` values for the different state
       */
      stateValue: {
        type: Object
      }
    };
  }

  get logo() {
    return this.selectShadow('#logo');
  }

  updated(props) {
    if (props.has('isSmall')) {
      this.observeIsSmall(this.isSmall);
    }
    if (props.has('state')) {
      this.observeState(this.state, this.duration);
    }
  }

  observeIsSmall(isSmall) {
    if (isSmall) {
      this.logo
        .transition()
        .duration(this.duration)
        .attr('viewBox', '0 158 935 466');
      this.state = 'oneline';
      return;
    }
    this.state = 'square';
    this.logo
      .transition()
      .duration(this.duration)
      .attr('viewBox', '0 -100 935 935');
  }

  observeState(state, duration) {
    const value = this.stateValue[state];
    if (state === 'square') {
      this.isSmall = false;
    }
    if (value) {
      // var logo = selectShadow('#logo', this);

      ['d', 'transform', 'opacity'].map((name) => {
        this.logo.selectAll('.' + name)
          .transition()
          .duration(function(d, i) {
            if (!value[name + 'Duration']) {
              return duration;
            }
            return value[name + 'Duration'][i] || duration;
          })
          .delay(function(d, i) {
            var delay = value[name + 'Delay'];
            if (!delay) {
              return 0;
            }
            return delay[i] == 0 ? 0 : (delay[i] || duration);
          })
          .attr(name, function(d, i) {
            return value[name][i];
          });
      });
    }
  }


}
// Register the new element with the browser.
customElements.define('preignition-logo', PreignitionLogo);
